import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    drawer: null,
    ua: '',
    isInCall: false,
    isCallOut: 0,
    permissions: [],
    module: {
      schoolLevelId: '',
      typeId: ''
    },
    isManager: 0,
    listType: null,
    listSchoolLevel: null,
    listSchoolLevelDrawer: null,
    statusTutor:false,
    vhData: {},
    listActionLogType: null,
    isAutoCall: false,
    listContact: [],
    autoCallIndex: 0,
    isCallWithBrandName: false,
    selectedCallOptions: { type: 'auto' },
    isInitCareSoft: false,
    isInitOds: false,
    isDefaultAuto: null,
    listModuleUser: null,
    listCacheBonusByBlock: [],
    LEVEL_ENGLISH: [],
    LEVEL_MATH: [],
    LEVEL_KHTN: [],
    SUBJECT_ERP: [],
    SUBLEVEL_ERP: [],
    redirectDomain: {},
    listUserNeedRedirect: [],
    listUserException: [],
    isPermissionModuleReport: false,
    notifications: [],
    unreadNotificationCount: 0
  },
  mutations: {
    SET_PERMISSION_MODULE_REPORT(state, payload) {
      state.isPermissionModuleReport = payload;
    },
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
    SET_UA (state, payload) {
      state.ua = payload
    },
    SET_IN_CALL (state, payload) {
      state.isInCall = payload
    },
    SET_CALL_OUT (state, payload) {
      state.isCallOut = payload
    },
    SET_PERMISSION (state, payload) {
      state.permissions = payload
    },
    SET_MANAGER (state, payload) {
      state.isManager = payload
    },
    SET_MODULE (state, payload) {
      state.module = payload
    },
    SET_LIST_TYPE (state, payload) {
      state.listType = payload
    },
    SET_LIST_SCHOOL_LEVEL (state, payload) {
      state.listSchoolLevel = payload
    },
    SET_LIST_SCHOOL_LEVEL_DRAWER (state, payload) {
      state.listSchoolLevelDrawer = payload
    },
    CHECK_STATUS_QUICKVIEW(state, payload) {
      state.statusTutor = payload
    },
    SET_VH_UPDATE_DATA (state, payload) {
      for (const [key, value] of Object.entries(payload)) {
        state.vhData[key] = value
      }
    },
    SET_LIST_ACTION_LOG_TYPE (state, payload) {
      state.listActionLogType = payload
    },
    SET_AUTO_CALL_STATE (state, payload) {
      state.isAutoCall = payload;
    },
    SET_AUTO_CALL_INDEX (state, payload) {
      state.autoCallIndex = payload;
    },
    SET_LIST_CONTACT (state, payload) {
      state.listContact = payload;
    },
    SET_CALL_WITH_BRAND_NAME (state, payload) {
      state.isCallWithBrandName = payload;
    },
    SET_SELECTED_CALL_OPTION (state, payload) {
      state.selectedCallOptions = payload;
    },
    SET_IS_INIT_CARE_SOFT (state, payload) {
      console.log('SET_IS_INIT_CARE_SOFT', payload);
      state.isInitCareSoft = payload;
    },
    SET_IS_INIT_ODS (state, payload) {
      console.log('SET_IS_INIT_ODS', payload);
      state.isInitOds = payload;
    },
    SET_DEFAULT_TYPE_AUTO (state, payload) {
      state.isDefaultAuto = payload;
    },
    SET_LIST_MODULE_USER (state, payload) {
      state.listModuleUser = payload
    },
    SET_LIST_BONUS_BY_BLOCK (state, payload) {
      state.listCacheBonusByBlock = payload
    },
    SET_CONFIG(state, { mathLevels, englishLevels, khtnLevels, subjects, subLevels }) {
      state.LEVEL_MATH = mathLevels;
      state.LEVEL_ENGLISH = englishLevels;
      state.SUBJECT_ERP = subjects;
      state.SUBLEVEL_ERP = subLevels;
      state.LEVEL_KHTN = khtnLevels;
    },
    SET_REDIRECT_DOMAIN(state, payload) {
      state.redirectDomain = payload;
    },
    SET_LIST_USER_REDIRECT(state, payload) {
      state.listUserNeedRedirect = payload;
    },
    SET_LIST_USER_EXCEPTION(state, payload) {
      state.listUserException = payload;
    },
    ADD_APP_NOTIFICATION(state, payload) {
      state.notifications.unshift({
        type: payload.type || 'info',
        title: payload.title || '',
        message: payload.message || '',
        code: payload.code || '',
        amount: payload.amount || null,
        timestamp: payload.timestamp || new Date().toISOString(),
        uid: Date.now() + Math.random(),
        ...payload
      });
      // Giới hạn số lượng thông báo tối đa là 50
      if (state.notifications.length > 50) {
        state.notifications = state.notifications.slice(0, 50);
      }
    },
    SET_UNREAD_NOTIFICATION_COUNT(state, payload) {
      state.unreadNotificationCount = payload;
    },
    REMOVE_APP_NOTIFICATION_BY_INDEX(state, index) {
      state.notifications.splice(index, 1);
    },
    CLEAR_APP_NOTIFICATIONS(state) {
      state.notifications = [];
    },
    SET_APP_NOTIFICATIONS(state, payload) {
      state.notifications = payload || [];
    },
    APPEND_APP_NOTIFICATIONS(state, payload) {
      if (payload && Array.isArray(payload)) {
        state.notifications = [...state.notifications, ...payload];
      }
    },
  },
  actions: {
    SET_PERMISSION_MODULE_REPORT(store, payload) {
      store.commit('SET_PERMISSION_MODULE_REPORT', payload);
    },
    SET_UA (store, ua) {
      store.commit('SET_UA', ua)
    },
    SET_IN_CALL (store, isInCall) {
      store.commit('SET_IN_CALL', isInCall)
    },
    SET_CALL_OUT (store, isCallOut) {
      store.commit('SET_CALL_OUT', isCallOut)
    },
    SET_PERMISSION (store, permissions) {
      store.commit('SET_PERMISSION', permissions)
    },
    SET_MANAGER (store, isManager) {
      store.commit('SET_MANAGER', isManager)
    },
    SET_MODULE (store, module) {
      store.commit('SET_MODULE', module)
    },
    SET_LIST_TYPE (store, listType) {
      store.commit('SET_LIST_TYPE', listType)
    },
    SET_LIST_SCHOOL_LEVEL (store, listSchoolLevel) {
      store.commit('SET_LIST_SCHOOL_LEVEL', listSchoolLevel)
    },
    SET_LIST_SCHOOL_LEVEL_DRAWER (store, listSchoolLevelDrawer) {
      store.commit('SET_LIST_SCHOOL_LEVEL_DRAWER', listSchoolLevelDrawer)
    },
    SET_VH_UPDATE_DATA (store, vhData) {
      store.commit('SET_VH_UPDATE_DATA', vhData)
    },
    SET_LIST_ACTION_LOG_TYPE (store, listActionLogType) {
      store.commit('SET_LIST_ACTION_LOG_TYPE', listActionLogType)
    },
    SET_LIST_MODULE_USER (store, listModuleUser) {
      store.commit('SET_LIST_MODULE_USER', listModuleUser)
    },
    SET_LIST_BONUS_BY_BLOCK (store, data) {
      let newList = store.state.listCacheBonusByBlock;
      if (data.type == 'delete') {
        newList = newList.filter((item) => item.idBlock !== data.object.idBlock)
        store.commit("SET_LIST_BONUS_BY_BLOCK", newList);
      } else {
        newList.push(data.object);
        store.commit("SET_LIST_BONUS_BY_BLOCK", newList);
      }
    },
    updateConfig({ commit }, payload) {
      commit('SET_CONFIG', payload)
    },
    setListUserNeedRedirect({ commit }, payload) {
      commit('SET_LIST_USER_REDIRECT', payload)
    },
    setRedirectDomain({ commit }, payload) {
      commit('SET_REDIRECT_DOMAIN', payload)
    },
    setListUserException({ commit }, payload) {
      commit('SET_LIST_USER_EXCEPTION', payload)
    },
  },
})
